import type { KolPlatform } from "@/types/kol";
import { request } from "./transport";

export interface KolApplicationInput {
  name: string;
  email: string;
  platform: KolPlatform;
  handle: string;
  profile_url: string;
  follower_count: number;
  message: string;
}

export interface KolApplication extends KolApplicationInput {
  id: number;
  user_id: number;
  status: "pending" | "approved" | "rejected";
  review_note: string | null;
  reviewed_at: string | null;
  kol_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface KolApplicationReview {
  decision: "approved" | "rejected";
  note: string;
  commission_bps: number;
}

export const kolApplications = {
  get: () =>
    request<{ application: KolApplication | null }>("/kol/application"),
  submit: (application: KolApplicationInput) =>
    request<{ application: KolApplication }>("/kol/application", {
      method: "POST",
      body: JSON.stringify({ application }),
    }),
  list: () =>
    request<{ applications: KolApplication[] }>("/admin/kol_applications"),
  review: (id: number, review: KolApplicationReview) =>
    request<{ application: KolApplication }>(`/admin/kol_applications/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ review }),
    }),
};
